import styles from './HeroHeader.module.css';
import Button from '../Button/Button'; // reuse your Button component
import buttonStyles from '../Button/Button.module.css';
import {useNavigate} from 'react-router-dom';

const HeroHeader = () => {
  const navigate = useNavigate();
  return (
    <header className={styles.heroheader}>
        <img src='/images/377StorageLogo.jpeg' alt='377 Storage Logo' className={styles.logo}/>

      <div className={styles.actions}>
        <Button className={buttonStyles.button}
        onClick={() => navigate('/login')}
        >
          Login</Button>
        <Button className={buttonStyles.button}
        onClick={() => navigate('/signup')}
        >
          Signup</Button>
      </div>
    </header>
  );
};

export default HeroHeader;
